/**
 * @class Oskari.mapframework.bundle.search.SearchBundle
 *
 * Definition for bundle. See source for details.
 */
Oskari.clazz.define("Oskari.mapframework.bundle.search.SearchBundle", function () {}, {
  "create": function create() {
    var me = this;
    var inst = Oskari.clazz.create("Oskari.mapframework.bundle.search.SearchBundleInstance");
    return inst;
  },
  "update": function update(manager, bundle, bi, info) {}
}, {
  "protocol": ["Oskari.bundle.Bundle", "Oskari.mapframework.bundle.extension.ExtensionBundle"],
  "source": {
    "scripts": [{
      "type": "text/javascript",
      "src": "../../../../bundles/vapaka/bundle/search/instance.js"
    }, {
      "type": "text/javascript",
      "src": "../../../../bundles/vapaka/bundle/search/Flyout.js"
    }, {
      "type": "text/javascript",
      "src": "../../../../bundles/vapaka/bundle/search/Tile.js"
    }, {
      "type": "text/css",
      "src": "../../../../resources/vapaka/bundle/search/css/style.css"
    }],
    "locales": [{
      "lang": "fi",
      "type": "text/javascript",
      "src": "../../../../bundles/vapaka/bundle/search/resources/locale/fi.js"
    }, {
      "lang": "sv",
      "type": "text/javascript",
      "src": "../../../../bundles/vapaka/bundle/search/resources/locale/sv.js"
    }, {
      "lang": "en",
      "type": "text/javascript",
      "src": "../../../../bundles/vapaka/bundle/search/resources/locale/en.js"
    }]
  },
  "bundle": {
    "manifest": {
      "Bundle-Identifier": "search",
      "Bundle-Name": "search",
      "Bundle-Author": [{
        "Name": "jjk",
        "Organisation": "nls.fi",
        "Temporal": {
          "Start": "2009",
          "End": "2011"
        },
        "Copyleft": {
          "License": {
            "License-Name": "EUPL",
            "License-Online-Resource": "http://www.paikkatietoikkuna.fi/license"
          }
        }
      }],
      "Bundle-Name-Locale": {
        "fi": {
          "Name": " style-1",
          "Title": " style-1"
        },
        "en": {}
      },
      "Bundle-Version": "1.0.0",
      "Import-Namespace": ["Oskari", "jquery"],
      "Import-Bundle": {}
    }
  },
  /**
   * @static
   * @property dependencies
   */
  "dependencies": ["jquery"]
});
Oskari.bundle_manager.installBundleClass("search", "Oskari.mapframework.bundle.search.SearchBundle");
import '../../../../bundles/vapaka/bundle/search/instance.js'
import '../../../../bundles/vapaka/bundle/search/Flyout.js'
import '../../../../bundles/vapaka/bundle/search/Tile.js'
import '../../../../resources/vapaka/bundle/search/css/style.css'